import { render, staticRenderFns } from "./ManageCommittees.vue?vue&type=template&id=407d943b&scoped=true"
import script from "./ManageCommittees.vue?vue&type=script&lang=js"
export * from "./ManageCommittees.vue?vue&type=script&lang=js"
import style0 from "./ManageCommittees.vue?vue&type=style&index=0&id=407d943b&prod&lang=css"
import style1 from "./ManageCommittees.vue?vue&type=style&index=1&id=407d943b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407d943b",
  null
  
)

export default component.exports